var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 0C1.19333 0 0 1.19333 0 2.66667V21.3333C0 22.8067 1.19333 24 2.66667 24H21.3333C22.8067 24 24 22.8067 24 21.3333V2.66667C24 1.19333 22.8067 0 21.3333 0H2.66667ZM2.66667 2.66667H21.3333V21.3333H2.66667V2.66667ZM6.3724 4.42188C5.22973 4.42188 4.54427 5.10877 4.54427 6.02344C4.54427 6.9381 5.22981 7.6224 6.25781 7.6224C7.40048 7.6224 8.08594 6.9381 8.08594 6.02344C8.08594 5.10877 7.4004 4.42188 6.3724 4.42188ZM4.63542 9.33333V18.6667H8V9.33333H4.63542ZM10.776 9.33333V18.6667H14.1406V13.5651C14.1406 12.0464 15.2241 11.8281 15.5495 11.8281C15.8748 11.8281 16.7448 12.1544 16.7448 13.5651V18.6667H20V13.5651C20 10.6358 18.6983 9.33333 17.0703 9.33333C15.4423 9.33333 14.574 9.87542 14.1406 10.6354V9.33333H10.776Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinicon);
export default __webpack_public_path__ + "static/media/linkdin icon.fedd885c1fbc734ad5efadbc439ffbdc.svg";
export { ForwardRef as ReactComponent };